"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostgresQueries = exports.validatePostgresQuery = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const postgresConfig_1 = require("./postgresConfig");
const getPostgresFormulaConfigErrors = (params) => {
    const { parameterConfigKey, postgresQueryName, variableNames } = params;
    const { engineVersion, formula } = params.formulaConfig;
    const errors = [];
    if (engineVersion !== finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1) {
        errors.push(`Error in [postgresQuery:${postgresQueryName}] [parameterConfig:${parameterConfigKey}]. Unsupported formula engine ${engineVersion}.`);
        return { errors };
    }
    const formulaErrors = (0, formula_engine_1.getFormulaErrors)(formula, variableNames);
    formulaErrors.errorMessages.forEach((err) => {
        errors.push(`Error in [postgresQuery:${postgresQueryName}] [parameterConfig:${parameterConfigKey}] [error:${err}]`);
    });
    return { errors };
};
const validatePostgresQuery = (params) => {
    const { postgresQuery } = params;
    const { name, variables, parameterConfig } = postgresQuery;
    const errors = [];
    try {
        const parsedVariables = variables.map(({ name: varName, value, parseNumber }) => ({
            name: varName,
            value: common_1.stringConversion.parseStringValueToSqlPrimitive({
                value,
                // We're actually parsing a string here to potentially another type.
                // "parseNumber" here represents the trigger whether to attempt parsing
                // the input value (which is a string)
                parseString: parseNumber,
            }),
        }));
        const keyVariableMap = (0, formula_engine_1.keyByVariableName)(parsedVariables);
        if (keyVariableMap.errors.length > 0) {
            keyVariableMap.errors.forEach((err) => errors.push(`Error creating variables [postgresQuery:${name}] [message:${err}]`));
            return { errors };
        }
        const variableNames = new Set(Object.keys(keyVariableMap.keyMap));
        for (const [key, config] of Object.entries(parameterConfig)) {
            const { type } = config;
            switch (type) {
                case 'formula': {
                    const formulaValidate = getPostgresFormulaConfigErrors({
                        formulaConfig: config,
                        variableNames,
                        parameterConfigKey: key,
                        postgresQueryName: name,
                    });
                    formulaValidate.errors.forEach((err) => errors.push(err));
                    break;
                }
                case 'tAccountDetailsArray':
                case 'orgProvidedInputKey':
                case 'capitalProviderSlugArray': {
                    // These configs are validated during save / commit since it requires
                    // additional async calls
                    break;
                }
                case 'assetVerificationStatusArray':
                case 'reportingPeriod': {
                    // There is nothing to logically validate at this point, config
                    // is type safe, and checked by typeguard.
                    // As config complexity grows, we may need logical checks here
                    break;
                }
                default:
                    errors.push(`Detected unsupported parameter configuration [type:${type}] [postgresQuery:${name}] [parameterConfig:${key}]`);
            }
        }
        // If already incurred errors, can return early and no need to evaluate
        // the underlying params / config itself
        if (errors.length > 0) {
            return { errors };
        }
        const postgresParams = (0, postgresConfig_1.createPostgresQueryParams)({
            postgresQuery,
        });
        if (!postgresParams.isValid) {
            postgresParams.errors.forEach((err) => errors.push(err));
        }
        return { errors };
    }
    catch (err) {
        const errorMessage = `Error during validatePostgresQuery for [postgres:${postgresQuery.name}] [message:${(0, common_1.getErrorMessage)(err)}]`;
        errors.push(errorMessage);
        return { errors };
    }
};
exports.validatePostgresQuery = validatePostgresQuery;
const validatePostgresQueries = (params) => {
    const queryResultVariablesSet = new Set();
    const errors = [];
    for (const postgresQuery of params.postgresQueries) {
        const pgValidate = (0, exports.validatePostgresQuery)({ postgresQuery });
        pgValidate.errors.forEach((err) => errors.push(err));
        if (queryResultVariablesSet.has(postgresQuery.name)) {
            errors.push(`Detected duplicate postgres query name: ${postgresQuery.name}`);
        }
        else {
            queryResultVariablesSet.add(postgresQuery.name);
        }
    }
    const queryResultVariables = Array.from(queryResultVariablesSet);
    return { queryResultVariables, errors };
};
exports.validatePostgresQueries = validatePostgresQueries;
//# sourceMappingURL=postgresQuery.js.map